import React from 'react';
import { Modal, Table, Input, Button } from 'antd';
import { Search } from 'lucide-react';
import { useStoreSearch } from './contractElements.controller';

const columns = [
    {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
        render: (text) => <span className="text-surface-900">{text}</span>
    },
    {
        title: 'Cliente',
        dataIndex: 'clientName',
        key: 'clientName',
        render: (text) => <span className="text-surface-600">{text}</span>
    },
    {
        title: 'Tipo de PDV',
        dataIndex: 'storeType',
        key: 'storeType',
        render: (text) => <span className="text-surface-600">{text}</span>
    },
    {
        title: 'Dirección',
        dataIndex: 'address',
        key: 'address',
        render: (text) => <span className="text-xs text-surface-500">{text}</span>
    }
];

const StoreSelectionModal = ({ isOpen, setIsOpen, setSelectedStores, selectedStores, stores }) => {
    const { filteredStores, searchText, handleSearch } = useStoreSearch(stores);

    const rowSelection = {
        selectedRowKeys: selectedStores,
        onChange: (storeIds) => setSelectedStores(storeIds),
        preserveSelectedRowKeys: true,
        getCheckboxProps: (record) => ({
            name: record.name
        })
    };

    return (
        <Modal
            title="Seleccionar Pisos de Venta"
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            width={800}
            footer={[
                <Button key="cancel" onClick={() => setIsOpen(false)}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={() => setIsOpen(false)}>
                    Seleccionar ({selectedStores.length})
                </Button>
            ]}>
            <div className="mb-4">
                <Input
                    placeholder="Buscar por nombre o cliente"
                    prefix={<Search className="text-surface-400" />}
                    value={searchText}
                    onChange={(e) => handleSearch(e.target.value)}
                    allowClear
                />
            </div>
            <Table
                rowSelection={rowSelection}
                columns={columns}
                dataSource={filteredStores}
                rowKey="_id"
                size="middle"
                pagination={{
                    pageSize: 10,
                    showSizeChanger: false
                }}
                scroll={{ y: 400 }}
            />
        </Modal>
    );
};

export default StoreSelectionModal;
